import React from "react";
import PropTypes from "prop-types";
import { Button, Confirm } from "semantic-ui-react";

const propTypes = {
  handleClick: PropTypes.func.isRequired,
  headerText: PropTypes.string,
  content: PropTypes.string,
  floated: PropTypes.any,
  basic: PropTypes.bool,
  size: PropTypes.string
};

const defaultProps = {
  floated: "right",
  basic: true,
  size: null
};

class BotonBorrar extends React.Component {
  state = { showModal: false };

  handleShow = () => this.setState({ showModal: true });
  handleClose = () => this.setState({ showModal: false });
  borrar = () => {
    this.props.handleClick(this.props.data);
    this.handleClose();
  };

  render() {
    return (
      <React.Fragment>
        <Button
          basic={this.props.basic}
          circular
          floated={this.props.floated}
          icon="trash"
          onClick={this.handleShow}
          size={this.props.size}
        />

        <Confirm
          open={this.state.showModal}
          header={this.props.headerText}
          content={this.props.content}
          onCancel={this.handleClose}
          onConfirm={this.borrar}
          cancelButton="No"
          confirmButton="Si"
        />
      </React.Fragment>
    );
  }
}

BotonBorrar.defaultProps = defaultProps;

BotonBorrar.propTypes = propTypes;

export default BotonBorrar;



// WEBPACK FOOTER //
// ./src/pages/shared/botones/BotonBorrar.jsx